const $window = $(window);
const $document = $(document);
const $main = $('.main');

const $container = $('.js-scroll-container');
const $stickyElement = $('.js-sticky');

let headerHeight = $('.header').outerHeight();
let sidebrHeight = $window.height() - headerHeight;

let scrollTop = 0;

if ($container.length !== 0) {
    $window
        .on('load resize orientationchange', function() {
            headerHeight = $('.header').outerHeight();
            sidebrHeight = $window.height() - headerHeight;

            $main.css('padding-top', headerHeight);
            $stickyElement.css('height', sidebrHeight);
        })
        .on('load scroll resize orientationchange', function() {
            scrollTop = $document.scrollTop();
            let containerBottom = $container.offset().top + $container.height();

            $stickyElement.toggleClass('is-sticked--bottom', scrollTop + $window.height() >= containerBottom);
        });
}
